import Vue from 'vue';
import FileUploaderGroup from '@/vue/components/FileUploaderGroup.vue';

const fileUploads = Array.from(document.querySelectorAll('.File-upload'));

fileUploads.forEach((uploader) => {
    new Vue({
        el: uploader,
        render: (h) => {
            const name = uploader.previousElementSibling.name;
            uploader.previousElementSibling.remove();
            return h(FileUploaderGroup, {
                props: {
                    required: uploader.dataset.required === 'true',
                    name: name,
                    fileLimit: parseInt(uploader.dataset.fileLimit)
                }
            });
        }
    });
});
